import { APIModel, APIModelImpl, APIModelHandler } from '../../../../toolkit/uicomponentapimodel';
import { BaseContext } from '../../../../../utils/basecontext';
import { BannerSearchDtoImpl } from '../../../../../core/dto/bannersearch/bannersearchdto';
import { BannerSearchResponse } from '../../../../../core/api/banner/bannersearch/bannersearchresponse';
import { BannerSearchRequestImpl } from '../../../../../core/api/banner/bannersearch/bannersearchrequest';
import { BannerProcessorFactory } from '../../../../../core/processorfactory/bannerprocessorfactory';


export interface BannerSearchListAPIModel extends APIModel
{
    getListofBannerTones(order: string, type: string, searchKey: string, startIndex: number, offset: number): void;
}

export class BannerSearchListAPIModelImpl extends APIModelImpl implements BannerSearchListAPIModel
{
    private bannerProcessor: BannerProcessorFactory;
   
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler)
    {
        super(applicationContext, apiModelHandler);

        this.bannerProcessor = this.getAPIProcesssorFactory().getBannerAPIProcessorFactory();
    }

    getListofBannerTones(order: string, type: string, searchKey: string,startIndex: number, offset: number): void
    {
        let bannerDto = new BannerSearchDtoImpl();
        bannerDto.setPageNumber(startIndex);
        bannerDto.setPagePerCount(offset);
        bannerDto.setType("BS");
        bannerDto.setSearchKey(searchKey);
        bannerDto.setLanguage(this.getContext().getUserContext().getLanguage());

       this.bannerProcessor.getBannerSearch()
                   .success((bannerResponse : BannerSearchResponse)=>
                    {
                        this.getAPIModelHandler().onSuccess(bannerResponse.getAPIFeature(), 
                        bannerResponse.getDescription(), bannerResponse.getListOfSearchBannerDtos());
                    })
                  .failure((bannerResponse : BannerSearchResponse)=>
                  {
                      this.getAPIModelHandler().onFailure(bannerResponse.getAPIFeature(), 
                      bannerResponse.getDescription(), bannerResponse);
                    })
                  .execute(new BannerSearchRequestImpl(bannerDto));    
    }
}


 


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/banner/bannerlist/bannersearchlistapimodel.tsx